import { useEffect } from 'react';

/**
 * Animacao de entrada dos blocos `.reveal` — mesma logica do script.js do Codex:
 * cada bloco ganha um atraso de (indice % 4) * 45ms e aparece ao entrar 8% na tela.
 */
export function useReveal() {
  useEffect(() => {
    const reveals = Array.from(document.querySelectorAll<HTMLElement>('.reveal'));
    if (!reveals.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach((el, i) => {
      el.style.transitionDelay = `${(i % 4) * 45}ms`;
      io.observe(el);
    });
    return () => io.disconnect();
  }, []);
}
